import $ from 'jquery';
import BaseEvent from './base-event';

export default class FilterEvents extends BaseEvent {
    constructor() {
        super({
            event_id: '13',
            category: 'filter',
            action: 'click',
        });

        this.init();
    }

    init() {
        this.onFilterClick();
    }

    onFilterClick() {
        $('.feed-filters__list-link, .feed-filters__reset').on('click', (e) => {
            this.fireEvent({
                destination_url: e.currentTarget.href,
                label: this.toNormalizedString(e.currentTarget.innerText),
            });
        });
    }
}
